// React
import React from "react";
import GraphDoubleAxis from "common/ui/components/graphs/GraphDoubleAxis";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class GraphTwoSeries extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { title, hAxisLabel, vAxis1Label, fromDate, toDate } = this.props;
        let { seriesA, seriesB, labelSeriesA, labelSeriesB, colourSeriesA, colourSeriesB } = this.props;
        // Merge the three series into one
        let series = [];
        for (let i = 0; i < seriesA.length; i++) {
            series.push([seriesA[i][0], seriesA[i][1], seriesB[i][1]]);
        }
        let seriesLabels = [labelSeriesA, labelSeriesB];
        const colours = [colourSeriesA, colourSeriesB];
        return (React.createElement(GraphDoubleAxis, { title: title, xAxis: hAxisLabel, yAxis: vAxis1Label, fromDate: fromDate, toDate: toDate, series: series, seriesColours: colours, seriesLabels: seriesLabels }));
    }
}
